/* eslint-disable camelcase */
import type * as React from 'react';
import { graphql } from 'react-apollo';

import { compose } from 'recompose';

import type { OccupationMapping } from 'bundles/enterprise-admin-skills/components/types';
import GetAllOccupations from 'bundles/enterprise-skillset-bank/queries/GetAllOccupations.graphql';
import type {
  GetAllOccupations_Dedupe1Query as GetAllOccupationsQueryData,
  GetAllOccupations_Dedupe1QueryVariables,
} from 'bundles/enterprise-skillset-bank/queries/__generated__/GetAllOccupations';
import Naptime from 'bundles/naptimejs';
import type { SkillSet } from 'bundles/naptimejs/resources/skillSets.v1';
import SkillSets from 'bundles/naptimejs/resources/skillSets.v1';

type PropsFromNaptime = {
  allSkillSets?: SkillSet[];
};

type PropsFromGraphql = {
  occupations?: OccupationMapping[];
};

export type PropsFromWithSkillsData = PropsFromNaptime & PropsFromGraphql;

export const withSkillsData = <PropsFromCaller,>(
  Component: React.ComponentType<PropsFromCaller & PropsFromWithSkillsData>
) =>
  compose<PropsFromCaller & PropsFromWithSkillsData, PropsFromCaller>(
    Naptime.createContainer(() => ({
      allSkillSets: SkillSets.finder('filter', {
        params: { limit: 9999 },
        fields: [
          'academyIds',
          'lure',
          'occupationId',
          'functionId',
          'industryId',
          'targetSkillProfileType',
          'targetProficiencies',
          'targetSkillProfileName',
          'description',
        ],
        required: false,
      }),
    })),
    graphql<PropsFromNaptime, GetAllOccupationsQueryData, GetAllOccupations_Dedupe1QueryVariables, PropsFromGraphql>(
      GetAllOccupations,
      {
        skip: (props) => !props.allSkillSets,
        options: () => ({
          errorPolicy: 'all',
          context: { clientName: 'gatewayGql' },
        }),
        props: ({ data }) => {
          const occupations = data?.Occupations?.getAllOccupations?.elements;
          return { occupations };
        },
      }
    )
  )(Component);
